module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_L5-132e63d20f1e5c4c24410976de530885.webp";